<template>
  <slot name="title-bar">
    <div class="title-bar">
      <h1><slot name="title">Default Title</slot></h1>
    </div>
  </slot>
  <slot name="header" />
  <div class="data-container">
    <div v-for="(item, index) in items" :key="item.id" :class="computeClass(item.format)">
      <slot name="item" :item="item" :index="index" />
    </div>
  </div>
  <div v-if="items.length === 0" class="no-items">{{ $t('noData') }}</div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import { fetchList } from '../utils/api';

export default {
  name: 'GenericDataList',
  props: {
    apiEndpoint: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const items = ref([]);
    const apiBaseUrl = inject('apiBaseUrl');
    const { t } = useI18n();
    onMounted(async () => {
      if (props.data) {
        fetchList(t, `${apiBaseUrl}/list/${props.apiEndpoint}`, props.data).then((response) => {
          items.value = response.data.result;
        });
      } else {
        fetchList(t, `${apiBaseUrl}/list/${props.apiEndpoint}`).then((response) => {
          items.value = response.data.result;
        });
      }
    });
    return {
      t,
      items,
    };
  },
  methods: {
    getItems() {
      return this.items;
    },
    computeClass(format) {
      switch (format) {
        case 8:
        case 9:
          return 'data-4item';
        default:
          break;
      }
      return 'data-item';
    },
  },
};
</script>

<style>
.data-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 0px;
    grid-auto-rows: minmax(min-content, max-content);
}
.data-item {
  display: flex;
  box-sizing: border-box;
  padding: 5px;
  flex-direction: row;
  vertical-align: middle;
  line-height: 1.6;
}
.data-4item {
  display: flex;
  box-sizing: border-box;
  padding: 5px;
  flex-direction: row;
  vertical-align: middle;
  line-height: 1.6;
  grid-column: span 4;
}
.no-items {
  text-align: center;
}
@media (max-width: 1200px) {
  .data-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 800px) {
  .data-container {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 600px) {
  .data-container {
    grid-template-columns: 1fr;
  }
}
</style>
